import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form,Tab,Nav} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsBook, optionsDay, optionsPeriod2, optionsShift, optionsSubGroup, optionsSubject, optionsTeacher, optionssection, optionssemester, optionssession, roledrp } from '../../Helper'
import moment from 'moment'

import { newsApi } from '../../../utils/AdminDashApi/NewsApi'

const RoutineEntryComp = () => {
  
 
  const [newArr,setNewArr] = useState([])
  const headers = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Methods": "*",
    }
    const [classresponse, setclassresponse] = useState([]);
  useEffect(() => {
    const fetchClassDropdown = async () => {
        try {
            const classresponse = await axios.get(
                "https://sass.britishstandardschool.com/api/Public/ClassList",
                {},
                headers
            );
            setclassresponse(classresponse.data);            
        } catch (err) {
            if (err.classresponse) {
                console.error(err.classresponse.data);
                console.log(err.classresponse.status);
                console.log(err.classresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
        };
        fetchClassDropdown();
    }, []);

    const [sessionresponse, setsessionrsponse] = useState([]);
    useEffect(() => {
        const fetchSessionDropdown = async () => {
            try {
                const sessionresponse = await axios.get(
                    "https://sass.britishstandardschool.com/api/Public/SessionDropDown",
                    {},
                    headers
                );
                setsessionrsponse(sessionresponse.data);
                console.log(sessionresponse);
            } catch (err) {
                if (err.sessionresponse) {
                    console.error(err.sessionresponse.data);
                    console.log(err.sessionresponse.status);
                    console.log(err.sessionresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchSessionDropdown();
    }, []);
 
    const [session, setsession] = useState("");
    const [myclass, setmyclass] = useState("");
    const [semester, setsemester] = useState("");
    const [startDate, setstartDate] = useState("");
    const [endDate, setendDate] = useState("");
    const [section, setsection] = useState("");

    const [session2, setsession2] = useState("");
    const [myclass2, setmyclass2] = useState("");
    const [semester2, setsemester2] = useState("");
    const [startDate2, setstartDate2] = useState("");
   
    const [section2, setsection2] = useState("");

    const [sessionlabel, setsessionlabel] = useState("");
    const [myclasslabel, setmyclasslabel] = useState("");
    const [semesterlabel, setsemesterlabel] = useState("");
    const [startdatelabel, setstartdatelabel] = useState("");
    const [enddatelabel, setenddatelabel] = useState("");
    const [sectionlabel, setsectionlabel] = useState("");

    const [sessionlabel2, setsessionlabel2] = useState("");
    const [myclasslabel2, setmyclasslabel2] = useState("");
    const [semesterlabel2, setsemesterlabel2] = useState("");
    const [startdatelabel2, setstartdatelabel2] = useState("");    
    const [sectionlabel2, setsectionlabel2] = useState("");
    const [sessionvalueerr, setsessionvalueerr] = useState("");
    const [myclassvalueerr, setmyclassvalueerr] = useState("");
    const [semestervalueerr, setsemestervalueerr] = useState("");
    const [startdatevalueerr, setstartdatevalueerr] = useState("");
    const [enddatevalueerr, setenddatevalueerr] = useState("");
    const [sectionvalueerr, setsectionvalueerr] = useState("");

    const [sessionvalueerr2, setsessionvalueerr2] = useState("");
    const [myclassvalueerr2, setmyclassvalueerr2] = useState("");
    const [semestervalueerr2, setsemestervalueerr2] = useState("");
    const [startdatevalueerr2, setstartdatevalueerr2] = useState("");    
    const [sectionvalueerr2, setsectionvalueerr2] = useState("");

    const [shift, setshift] = useState("");
    const [shiftlabel, setshiftlabel] = useState("");
    const [shiftvalueerr, setshiftvalueerr] = useState("");

    const [period, setperiod] = useState("");
    const [periodlabel, setperiodlabel] = useState("");
    const [periodvalueerr, setperiodvalueerr] = useState("");

    const [subject, setsubject] = useState("");
    const [subjectlabel, setsubjectlabel] = useState("");
    const [subjectvalueerr, setsubjectvalueerr] = useState("");

    const [subgroup, setsubgroup] = useState("");
    const [subgrouplabel, setsubgrouplabel] = useState("");
    const [subgroupvalueerr, setsubgroupvalueerr] = useState("");

    const [teacher, setteacher] = useState("");
    const [teacherlabel, setteacherlabel] = useState("");
    const [teachervalueerr, setteachervalueerr] = useState("");

    const [book, setbook] = useState("");
    const [booklabel, setbooklabel] = useState("");
    const [bookvalueerr, setbookvalueerr] = useState("");

    const [day, setday] = useState("");
    const [daylabel, setdaylabel] = useState("");
    const [dayvalueerr, setdayvalueerr] = useState("");

    const [shift2, setshift2] = useState("");
    const [shiftlabel2, setshiftlabel2] = useState("");
    const [shiftvalueerr2, setshiftvalueerr2] = useState("");

    const [period2, setperiod2] = useState("");
    const [periodlabel2, setperiodlabel2] = useState("");
    const [periodvalueerr2, setperiodvalueerr2] = useState("");

    const [subject2, setsubject2] = useState("");
    const [subjectlabel2, setsubjectlabel2] = useState("");
    const [subjectvalueerr2, setsubjectvalueerr2] = useState("");

    const [subgroup2, setsubgroup2] = useState("");
    const [subgrouplabel2, setsubgrouplabel2] = useState("");
    const [subgroupvalueerr2, setsubgroupvalueerr2] = useState("");

    const [teacher2, setteacher2] = useState("");
    const [teacherlabel2, setteacherlabel2] = useState("");
    const [teachervalueerr2, setteachervalueerr2] = useState("");

    const [book2, setbook2] = useState("");
    const [booklabel2, setbooklabel2] = useState("");
    const [bookvalueerr2, setbookvalueerr2] = useState("");

    const [day2, setday2] = useState("");
    const [daylabel2, setdaylabel2] = useState("");
    const [dayvalueerr2, setdayvalueerr2] = useState("");
    
    const [totaldays, settotaldays] = useState("");
    const [totaldayslabel2, settotaldayslabel2] = useState("");
    const [totaldaysvalueerr2, settotaldaysvalueerr2] = useState("");

    
    

    const drpfuncclass=(myval,myid)=>{
        setmyclass(myid)
    }

    const drpfuncsession=(myval,myid)=>{
        setsession(myid)
    }
    const drpfuncsemester=(myval,myid)=>{
        setsemester(myid)
    }
    const drpfuncsection=(myval,myid)=>{
        setsection(myid)
    }
    const drpfuncshift=(myval,myid)=>{
        setshift(myid)
    }
    const drpfuncperiod=(myval,myid)=>{
        setperiod(myid)
    }
    const drpfuncsubject=(myval,myid)=>{
        setsubject(myid)
    }
    const drpfuncsubgroup=(myval,myid)=>{
        setsubgroup(myid)
    }
    const drpfuncteacher=(myval,myid)=>{
        setteacher(myid)
    }
    const drpfuncbook=(myval,myid)=>{
        setbook(myid)
    }
    const drpfuncday=(myval,myid)=>{
        setday(myid)
    }

    const drpfuncclass2 = (myval, myid) => {
        setmyclass2(myid);
      };
      
      const drpfuncsession2 = (myval, myid) => {
        setsession2(myid);
      };
      
      const drpfuncsemester2 = (myval, myid) => {
        setsemester2(myid);
      };
      
      const drpfuncsection2 = (myval, myid) => {
        setsection2(myid);
      };
      
      const drpfuncshift2 = (myval, myid) => {
        setshift2(myid);
      };
      
      const drpfuncperiod2 = (myval, myid) => {
        setperiod2(myid);
      };
      
      const drpfuncsubject2 = (myval, myid) => {
        setsubject2(myid);
      };
      
      const drpfuncsubgroup2 = (myval, myid) => {
        setsubgroup2(myid);
      };
      
      const drpfuncteacher2 = (myval, myid) => {
        setteacher2(myid);
      };
      
      const drpfuncbook2 = (myval, myid) => {
        setbook2(myid);
      };
      
      const drpfuncday2 = (myval, myid) => {
        setday2(myid);
      };

      const handletotaldays=(e)=>{
        settotaldays(e.target.value)
      }

    const handleStartDate = (startdatevar)=>{
        if(startdatevar != null){
          
            var dtmnt = startdatevar.$M + 1;
            var dtstart = startdatevar.$y + '-'+ dtmnt +'-'+ startdatevar.$D;
           
            console.log(dtstart)
            setstartDate(dtstart)
        }
    }
    const handleEndDate = (enddatevar)=>{
        if(enddatevar != null){
          
            var dtmnt = enddatevar.$M + 1;
            var dtend = enddatevar.$y + '-'+ dtmnt +'-'+ enddatevar.$D;
           
            console.log(dtend)
            setendDate(dtend)
        }
    }
  
    const handleStartDate2 = (startdatevar)=>{
        if(startdatevar != null){
          
            var dtmnt = startdatevar.$M + 1;
            var dtstart = startdatevar.$y + '-'+ dtmnt +'-'+ startdatevar.$D;
           
            console.log(dtstart)
            setstartDate2(dtstart)
        }
    }
   

    useEffect(()=>{
        console.log(session)
    },[session])

    const handlegenerateone = ()=>{
        if(session==""){
            console.log("im inside")
            setsessionlabel("session required")
            setsessionvalueerr("err")
        }else{
            setsessionlabel("")
            setsessionvalueerr("")
        }
        if(myclass==""){
            console.log("im inside")
            setmyclasslabel("class required")
            setmyclassvalueerr("err")
        }else{
            setmyclasslabel("")
            setmyclassvalueerr("")
        }
        if(semester==""){            
            setsemesterlabel("semester required")
            setsemestervalueerr("err")
        }else{
            setsemesterlabel("")
            setsemestervalueerr("")
        }
        if(startDate.length==0){            
            setstartdatelabel("start date required")
            setstartdatevalueerr("err")
        }else{
            setstartdatelabel("")
            setstartdatevalueerr("")
        }
        if(endDate.length==0){            
            setenddatelabel("end date required")
            setenddatevalueerr("err")
        }else{
            setenddatelabel("")
            setenddatevalueerr("")
        }
        if(section==""){            
            setsectionlabel("section required")
            setsectionvalueerr("err")
        }else{
            setsectionlabel("")
            setsectionvalueerr("")
        }
        if(shift==""){            
            setshiftlabel("shift required")
            setshiftvalueerr("err")
        }else{
            setshiftlabel("")
            setshiftvalueerr("")
        }
        if(period==""){            
            setperiodlabel("period required")
            setperiodvalueerr("err")
        }else{
            setperiodlabel("")
            setperiodvalueerr("")
        }
        if(subject==""){            
            setsubjectlabel("subject required")
            setsubjectvalueerr("err")
        }else{
            setsubjectlabel("")
            setsubjectvalueerr("")
        }
        if(subgroup==""){            
            setsubgrouplabel("subgroup required")
            setsubgroupvalueerr("err")
        }else{
            setsubgrouplabel("")
            setsubgroupvalueerr("")
        }
        if(teacher==""){            
            setteacherlabel("teacher required")
            setteachervalueerr("err")
        }else{
            setteacherlabel("")
            setteachervalueerr("")
        }
        if(book==""){            
            setbooklabel("book required")
            setbookvalueerr("err")
        }else{
            setbooklabel("")
            setbookvalueerr("")
        }
        if(day==""){            
            setdaylabel("day required")
            setdayvalueerr("err")
        }else{
            setdaylabel("")
            setdayvalueerr("")
        }
    }

    const handlegeneratetwo = ()=>{
        if (session2 === "") {
            console.log("im inside");
            setsessionlabel2("session required");
            setsessionvalueerr2("err");
          } else {
            setsessionlabel2("");
            setsessionvalueerr2("");
          }
          
          if (myclass2 === "") {
            console.log("im inside");
            setmyclasslabel2("class required");
            setmyclassvalueerr2("err");
          } else {
            setmyclasslabel2("");
            setmyclassvalueerr2("");
          }
          
          if (semester2 === "") {
            setsemesterlabel2("semester required");
            setsemestervalueerr2("err");
          } else {
            setsemesterlabel2("");
            setsemestervalueerr2("");
          }
          
          if (startDate2.length === 0) {
            setstartdatelabel2("start date required");
            setstartdatevalueerr2("err");
          } else {
            setstartdatelabel2("");
            setstartdatevalueerr2("");
          }
          
         
          
          if (section2 === "") {
            setsectionlabel2("section required");
            setsectionvalueerr2("err");
          } else {
            setsectionlabel2("");
            setsectionvalueerr2("");
          }
          
          if (shift2 === "") {
            setshiftlabel2("shift required");
            setshiftvalueerr2("err");
          } else {
            setshiftlabel2("");
            setshiftvalueerr2("");
          }
          
          if (period2 === "") {
            setperiodlabel2("period required");
            setperiodvalueerr2("err");
          } else {
            setperiodlabel2("");
            setperiodvalueerr2("");
          }
          
          if (subject2 === "") {
            setsubjectlabel2("subject required");
            setsubjectvalueerr2("err");
          } else {
            setsubjectlabel2("");
            setsubjectvalueerr2("");
          }
          
          if (subgroup2 === "") {
            setsubgrouplabel2("subgroup required");
            setsubgroupvalueerr2("err");
          } else {
            setsubgrouplabel2("");
            setsubgroupvalueerr2("");
          }
          
          if (teacher2 === "") {
            setteacherlabel2("teacher required");
            setteachervalueerr2("err");
          } else {
            setteacherlabel2("");
            setteachervalueerr2("");
          }
          
          if(book2==""){            
            setbooklabel2("book required")
            setbookvalueerr2("err")
        }else{
            setbooklabel2("")
            setbookvalueerr2("")
        }
        if(day2==""){            
            setdaylabel2("day required")
            setdayvalueerr2("err")
        }else{
            setdaylabel2("")
            setdayvalueerr2("")
        }
        if(totaldays==""){
            settotaldayslabel2("total days required")
            settotaldaysvalueerr2("err")
        }else{
            settotaldayslabel2("")
            settotaldaysvalueerr2("")
        }
          
    }

    // start
  return (
      <div className="d-flex flexvaluecomp">

          <SidebarOfAdash />
          <div className="contentpartwidthwrapper">
              <HeaderofAdash head="Routine Entry" />
              <div className="contentofadmindash contentflexvalue routineentry">
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                    <Col sm={3} className='m-auto'>
                    <Nav variant="pills" className="flex justify-content-center">
                        <div className="navwrap d-flex">

                        <Nav.Item>
                        <Nav.Link eventKey="first">Date</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="second">Day</Nav.Link>
                        </Nav.Item>
                        </div>
                    </Nav>
                    </Col>
                    <Col sm={12}>
                    <Tab.Content style={{marginTop:"60px"}}>
                        <Tab.Pane eventKey="first">
                            <Row>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Session</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err={sessionvalueerr=="err"?"err":""} func={drpfuncsession} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={sessionresponse} />
                                        </div>
                                        <label>{sessionlabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                <div className="basicinput">
                                        <p>Semester</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err={semestervalueerr=="err"?"err":""} func={drpfuncsemester} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssemester} />
                                        </div>
                                        <label>{semesterlabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                <div className="basicinput">
                                    <p>Start Date</p>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div className="inputgap">
                                    <DatePicker
                                        
                                        value={startDate}
                                        onChange={(newvaldob)=>handleStartDate(newvaldob)}
                                        renderInput={(params) => <TextField style={startdatevalueerr=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params}inputProps={{
                                            ...params.inputProps,
                                            placeholder: "Start Date"
                                            }} error={false} />}
                                    />
                                    <label>{startdatelabel}</label>
                                        </div>
                                    </LocalizationProvider>
                                </div>
                                </Col>
                                <Col lg={3}>
                                <div className="basicinput">
                                    <p>End Date</p>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div className="inputgap">
                                    <DatePicker
                                        
                                        value={endDate}
                                        onChange={(newvaldob)=>handleEndDate(newvaldob)}
                                        renderInput={(params) => <TextField style={enddatevalueerr=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}} {...params}inputProps={{
                                            ...params.inputProps,
                                            placeholder: "Start Date"
                                            }} error={false} />}
                                    />
                                    <label>{enddatelabel}</label>
                                        </div>
                                    </LocalizationProvider>
                                </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Class</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {myclassvalueerr=="err"?"err":""} func={drpfuncclass} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                        </div>
                                        <label>{myclasslabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Section</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {sectionvalueerr=="err"?"err":""} func={drpfuncsection} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                        </div>
                                        <label>{sectionlabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Shift</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {shiftvalueerr=="err"?"err":""} func={drpfuncshift} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                                        </div>
                                        <label>{shiftlabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Period</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {periodvalueerr=="err"?"err":""} func={drpfuncperiod} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsPeriod2} />
                                        </div>
                                        <label>{periodlabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Subject</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {subjectvalueerr=="err"?"err":""} func={drpfuncsubject} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubject} />
                                        </div>
                                        <label>{subjectlabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Subgroup</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {subgroupvalueerr=="err"?"err":""} func={drpfuncsubgroup} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubGroup} />
                                        </div>
                                        <label>{subgrouplabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Teacher</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {teachervalueerr=="err"?"err":""} func={drpfuncteacher} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsTeacher} />
                                        </div>
                                        <label>{teacherlabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Book</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {bookvalueerr=="err"?"err":""} func={drpfuncbook} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsBook} />
                                        </div>
                                        <label>{booklabel}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="basicinput">
                                        <p>Day</p>
                                        <div className="inputgap">
                                        <div className="dropdownwrapper">

                                            <Dropdown2 err = {dayvalueerr=="err"?"err":""} func={drpfuncday} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsDay} />
                                        </div>
                                        <label>{daylabel}</label>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div className="generatebutton">
                                <button onClick={handlegenerateone}>Generate</button>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                        <Row>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Session</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={sessionvalueerr2 === "err" ? "err" : ""} func={drpfuncsession2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={sessionresponse} />
                                </div>
                                <label>{sessionlabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Semester</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={semestervalueerr2 === "err" ? "err" : ""} func={drpfuncsemester2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssemester} />
                                </div>
                                <label>{semesterlabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Start Date</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap">
                                <DatePicker
                                    value={startDate}
                                    onChange={(newvaldob) => handleStartDate(newvaldob)}
                                    renderInput={(params) => <TextField style={startdatevalueerr2 === "err" ? { border: "1px solid #ED1C24", borderRadius: "10px" } : {}} {...params} inputProps={{ ...params.inputProps, placeholder: "Start Date" }} error={false} />}
                                />
                                <label>{startdatelabel2}</label>
                                </div>
                            </LocalizationProvider>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                                <p>Total Days</p>

                                <div className="inputgap">
                                    <input type="text"  style={totaldaysvalueerr2=="err"? {border:"1px solid #ED1C24"}:{}} vlaue={totaldays} onChange={handletotaldays} />
                                    <label>{totaldayslabel2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Class</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={myclassvalueerr2 === "err" ? "err" : ""} func={drpfuncclass2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                </div>
                                <label>{myclasslabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Section</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={sectionvalueerr2 === "err" ? "err" : ""} func={drpfuncsection2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                </div>
                                <label>{sectionlabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Shift</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={shiftvalueerr2 === "err" ? "err" : ""} func={drpfuncshift2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsShift} />
                                </div>
                                <label>{shiftlabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Period</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={periodvalueerr2 === "err" ? "err" : ""} func={drpfuncperiod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsPeriod2} />
                                </div>
                                <label>{periodlabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Subject</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={subjectvalueerr2 === "err" ? "err" : ""} func={drpfuncsubject2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubject} />
                                </div>
                                <label>{subjectlabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Subgroup</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={subgroupvalueerr2 === "err" ? "err" : ""} func={drpfuncsubgroup2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsSubGroup} />
                                </div>
                                <label>{subgrouplabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Teacher</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={teachervalueerr2 === "err" ? "err" : ""} func={drpfuncteacher2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsTeacher} />
                                </div>
                                <label>{teacherlabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Book</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={bookvalueerr2 === "err" ? "err" : ""} func={drpfuncbook2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsBook} />
                                </div>
                                <label>{booklabel2}</label>
                            </div>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">
                            <p>Day</p>
                            <div className="inputgap">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={dayvalueerr2 === "err" ? "err" : ""} func={drpfuncday2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsDay} />
                                </div>
                                <label>{daylabel2}</label>
                            </div>
                            </div>
                        </Col>
                        </Row>
                        <div className="generatebutton">
                                <button onClick={handlegeneratetwo}>Generate</button>
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                    </Col>
                </Row>
                </Tab.Container>
              </div>
          </div>
      </div>
  )
}


export default RoutineEntryComp